var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportBus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0c10.493 0 19 8.507 19 19s-8.507 19-19 19S0 29.493 0 19 8.507 0 19 0zm0 2C9.626 2 2 9.626 2 19c0 9.374 7.626 17 17 17 9.374 0 17-7.626 17-17 0-9.374-7.626-17-17-17zm8.461 5c1.344 0 2.448 1.026 2.534 2.318l.005.163V28a1 1 0 01-.883.993L29 29v1a1 1 0 01-.883.993L28 31h-4a1 1 0 01-.993-.883L23 30v-1h-8v1a1 1 0 01-.883.993L14 31h-4a1 1 0 01-.993-.883L9 30v-1a1 1 0 01-.993-.883L8 28V9.481c0-1.313 1.05-2.392 2.372-2.476L10.54 7h16.922zm.54 15H10v5h18v-5zm-14.5 1c.826 0 1.499.673 1.499 1.5s-.673 1.5-1.499 1.5A1.503 1.503 0 0112 24.5c0-.827.674-1.5 1.501-1.5zm11 0c.826 0 1.499.673 1.499 1.5s-.673 1.5-1.499 1.5A1.503 1.503 0 0123 24.5c0-.827.674-1.5 1.501-1.5zm3.5-8H10v5h18v-5zm-.54-6H10.54c-.26 0-.483.175-.53.396L10 9.481V13h18V9.481c0-.26-.247-.481-.539-.481zM23 10a1 1 0 110 2h-8a1 1 0 110-2z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconTransportBus;